import { Spinner } from '@crm/shared/ui/Spinner'

export const RouterHydrateFallback = () => (
  <div className='flex h-screen w-screen items-center justify-center'>
    <Spinner className='size-8' />
  </div>
)
